import axios from 'axios';
import {getHeaders, urls} from './urls';
import {CurrentUserModel, User, UserFilter} from '../../models/User';
import {apiUrl} from './servers';
import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, Resolve, RouterStateSnapshot} from '@angular/router';
import {BaseService} from './BaseService';

@Injectable({
  providedIn: 'root'
})
export class UserService extends BaseService<User, UserFilter> implements Resolve<User> {

  constructor() {
    super(urls.user);
  }

  async currentUser(): Promise<CurrentUserModel> {
    const endpoint = apiUrl + 'current';
    const response = await axios.get<CurrentUserModel>(endpoint, { data: {}, headers: getHeaders()});
    return response.data;
  }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<User> {
    return this.fetchById(route.params.id);
  }

}

export const userService = new UserService();
